import { TypedFormattedMessageFactory, useTypedIntlFactory } from 'locale/typedIntl';
import { Language } from 'shared/constants';
import enMessages from './en.json';
import esMessages from './es.json';
import frMessages from './fr.json';
import plMessages from './pl.json';

type FeedbackMessages = typeof enMessages;

export const messages: Record<Language, FeedbackMessages> = {
  EN: enMessages,
  ES: esMessages,
  FR: frMessages,
  PL: plMessages,
};

export const useTypedIntl = useTypedIntlFactory<keyof FeedbackMessages>();
export const TypedFormattedMessage = TypedFormattedMessageFactory<keyof FeedbackMessages>();
export type TypedIntlShape = ReturnType<typeof useTypedIntl>;
